import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { useScrollReveal, fadeUpVariants, staggerContainerVariants, cardVariants } from '../hooks/useScrollReveal'
import { useAdmin } from '../context/AdminContext'
import { FaAward } from 'react-icons/fa'

const COLOR = {
  blue:  { bg:'rgba(59,130,246,.07)',   border:'rgba(59,130,246,.2)',   text:'#3b82f6'  },
  green: { bg:'rgba(16,185,129,.07)',   border:'rgba(16,185,129,.2)',   text:'#10b981'  },
  orange:{ bg:'rgba(245,158,11,.07)',   border:'rgba(245,158,11,.2)',   text:'#f59e0b'  },
  yellow:{ bg:'rgba(234,179,8,.07)',    border:'rgba(234,179,8,.2)',    text:'#eab308'  },
  purple:{ bg:'rgba(16,185,129,.07)',   border:'rgba(16,185,129,.2)',   text:'#10b981'  },
  cyan:  { bg:'rgba(16,185,129,.07)',    border:'rgba(16,185,129,.2)',    text:'#10b981'  },
}

function CertCard({ cert }) {
  const c = COLOR[cert.color] || COLOR.blue
  return (
    <motion.div variants={cardVariants}
      whileHover={{ y: -4, borderColor: c.border, transition:{duration:.2} }}
      className="card p-5 flex flex-col gap-4">
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 ${cert.icon.length > 2 ? 'text-xs font-black uppercase tracking-widest' : 'text-2xl'}`}
          style={{ background: c.bg, border:`1px solid ${c.border}` }}>
          <span className="leading-none mt-[2px]">{cert.icon}</span>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display font-semibold text-primary text-sm leading-snug mb-1">{cert.title}</h3>
          <p className="text-sm font-semibold" style={{ color: c.text }}>{cert.issuer}</p>
        </div>
      </div>
      <div className="flex items-center justify-between pt-3" style={{ borderTop:'1px solid var(--border)' }}>
        <div className="flex items-center gap-2">
          <FaAward size={11} className="text-muted" />
          <span className="font-mono text-xs text-muted">{cert.date}</span>
        </div>
        {cert.credentialId && <span className="font-mono text-xs text-muted truncate max-w-[120px]">{cert.credentialId}</span>}
      </div>
    </motion.div>
  )
}

export default function Certificates() {
  const { ref, controls } = useScrollReveal()
  const { siteData, loading } = useAdmin()

  if (loading) return null
  return (
    <section id="certificates" className="py-28 relative overflow-hidden">
      <Helmet>
        <title>Certifications | Shiv Shankar Pandit</title>
        <meta name="description" content="My professional certifications and achievements." />
      </Helmet>
      <div className="absolute top-1/3 -right-64 w-[500px] h-[500px] rounded-full blur-[120px] opacity-[0.06] pointer-events-none orb-purple" />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div variants={staggerContainerVariants} initial="hidden" animate="visible">
          <motion.div variants={fadeUpVariants} className="mb-14">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
              <h1 className="section-heading">My <span className="gradient-text">Certifications</span></h1>

            </div>
          </motion.div>
          <motion.div variants={staggerContainerVariants} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {siteData.certificates.map(c => <CertCard key={c.id} cert={c} />)}
          </motion.div>
          {siteData.certificates.length === 0 && (
            <p className="text-center text-muted font-mono text-sm py-12">No certificates yet.</p>
          )}
        </motion.div>
      </div>
    </section>
  )
}
